import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';

import { HisSharedModule } from 'hisng';

import { IdentifierPanelComponent } from 'app/fs/res/publication/component/identifier/identifier-panel.component';
import { IdentifierDialogComponent } from './identifier-dialog.component';

@NgModule( {
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,

        // primeng
        AutoCompleteModule,
        ConfirmDialogModule,
        DialogModule,
        PanelModule,
        TableModule,

        // HIS
        HisSharedModule
    ],

    declarations: [
        IdentifierPanelComponent,
        IdentifierDialogComponent
    ],

    exports: [
        IdentifierPanelComponent,
        IdentifierDialogComponent
    ]
} )

export class IdentifierSharedModule { }
